import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders } from '@angular/common/http';

import { AngularFireDatabase } from 'angularfire2/database';
import { AngularFirestore } from 'angularfire2/firestore';
import {AngularFireAuth} from "angularfire2/auth";
import {UsuariosPersonalService} from "./usuarios-personal.service";
import {Router} from "@angular/router";


@Injectable()
export class ValidarDepartamentoService {

  constructor(
    private http:HttpClient,
    private afs:AngularFirestore,
    private afDB:AngularFireDatabase,
    private afAuth:AngularFireAuth,
    private usuariosService: UsuariosPersonalService,
    private route:Router) { }

  /**
   * Obtiene todas las confirmaciones
   */
  public validarPermiso(permiso,dpto){
    console.log("Validando permiso: " + permiso + " para el departamento: " + dpto);
      if(permiso == "Planeación" || permiso == "Mantenimiento")
      {
          alert("Estas ingresando al sistema antiguo, porfavor ingresa al nuevo panel de planeación y mantenimiento")
          this.afAuth.auth.signOut();
          this.usuariosService.auth = null;
          this.route.navigateByUrl('/');
      }
      else {
          if(permiso != dpto)
          {
              if(permiso != "GYO_Super_Admin" && permiso != "Admin")
              {
                  alert("No tienes permiso de acceder a esta sección");
                  this.afAuth.auth.signOut();
                  this.usuariosService.auth = null;
                  this.route.navigateByUrl('/');
              }
              else {
                  console.log("Access Granted")
              }
          }
          else {
              console.log("Access Granted")
          }
      }

  }
}



// WEBPACK FOOTER //
// E:/Github/trosten/trosten-web-app/src/app/services/validarDepartamento.ts